import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-12% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, eyebrow, title, className = "", testId }) => (
  <div className={className} data-testid={testId}>
    <Reveal>
      <span className="eyebrow flex items-center gap-4">
        <span>{index}</span>
        <span className="h-px w-10 bg-gold/60" />
        <span>{eyebrow}</span>
      </span>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight mt-6 text-ivory">
        {title}
      </h2>
    </Reveal>
  </div>
);

export const scrollTo = (href) => {
  if (window.__lenis) window.__lenis.scrollTo(href, { offset: -80 });
  else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};
